import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './style.css';
import { Icon } from '@iconify/react/dist/iconify.js';

const AddOnsExtras = ({ addOns, onAdd, onRemove, total }) => {
    const { t } = useTranslation();
    const [newAddOn, setNewAddOn] = useState({
        name: '',
        description: '',
        cost: ''
    });

    const handleAddNew = () => {
        if (newAddOn.name && newAddOn.cost) {
            onAdd(newAddOn);
            setNewAddOn({ name: '', description: '', cost: '' });
        }
    };

    return (
        <div className="quotation-addons-section">
            <div className="quotation-addons-header">
                <h2 className="quotation-section-title">{t('add-ons-extras')}</h2>
             
            </div>

            {/* Add-ons List */}
            <div className="quotation-addons-list">
                <div className="quotation-addons-list-header">
                    <span className="quotation-addon-col quotation-addon-col-name">{t('addon-name')}</span>
                    <span className="quotation-addon-col quotation-addon-col-description">{t('description')}</span>
                    <span className="quotation-addon-col quotation-addon-col-cost">{t('cost')}</span>
                    <span className="quotation-addon-col quotation-addon-col-actions"></span>
                </div>

     
                {/* Add New Add-on Form */}
                <div className="quotation-addon-new-form">
                    <input
                        type="text"
                        className="quotation-addon-input quotation-addon-col quotation-addon-col-name"
                        placeholder={t('postcare-recovery-suite')}
                        value={newAddOn.name}
                        onChange={(e) => setNewAddOn({ ...newAddOn, name: e.target.value })}
                    />
                    <input
                        type="text"
                        className="quotation-addon-input quotation-addon-col quotation-addon-col-description"
                        placeholder={t('upgraded-private-room-with-ensuite-assistant')}
                        value={newAddOn.description}
                        onChange={(e) => setNewAddOn({ ...newAddOn, description: e.target.value })}
                    />
                    <div className="quotation-addon-col quotation-addon-col-cost">
                        <div className="quotation-addon-cost-input-group">
                            <span className="quotation-addon-currency">$</span>
                            <input
                                type="number"
                                min="0"
                                step="0.01"
                                className="quotation-addon-input quotation-addon-cost-input"
                                placeholder="1200"
                                value={newAddOn.cost}
                                onChange={(e) => setNewAddOn({ ...newAddOn, cost: e.target.value })}
                            />
                        </div>
                    </div>
                    <div className="quotation-addon-col quotation-addon-col-actions">
                        <button 
                            className="quotation-addon-add-btn"
                            onClick={handleAddNew}
                            disabled={!newAddOn.name || !newAddOn.cost}
                        >
                            <Icon icon="mdi:plus" />
                        </button>
                    </div>
                </div>
            </div>
            {addOns.length === 0 ? (
                    <div className="quotation-addons-empty">
                        <p>{t('no-addons-added-yet')}</p>
                    </div>
                ) : (
                    addOns.map((addon, index) => (
                        <div key={index} className="quotation-addon-item">
                            <span className="quotation-addon-col quotation-addon-col-name">
                                {addon.name}
                            </span>
                            <span className="quotation-addon-col quotation-addon-col-description">
                                {addon.description}
                            </span>
                            <span className="quotation-addon-col quotation-addon-col-cost">
                                $ {parseFloat(addon.cost).toFixed(2)}
                            </span>
                            <div className="quotation-addon-col quotation-addon-col-actions">
                                <button 
                                    className="quotation-addon-remove-btn"
                                    onClick={() => onRemove(index)}
                                >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    ))
                )}

            {/* Total */}
            <div className="quotation-total-section">
                <div className="quotation-total-row">
                    <span className="quotation-total-label">{t('total-cost')}</span>
                    <span className="quotation-total-value">${total}</span>
                </div>
            </div>
        </div>
    );
};

export default AddOnsExtras;

